import { handleStatus500 } from 'api/Utility/HandleStatus500'
import AxiosInitializer from 'api/Utility/AxiosInitializer'
import getToken from 'lib/authentication/GetToken'
import apiWrapper from 'api/Utility/ApiWrapper'

const axiosRequest = (extraParams: any = {}) =>
  AxiosInitializer({
    token: getToken(),
    paramsSerializerConfig: true,
    ...extraParams,
  })

const brainstormerAPI = {
  getAdministratorEmails: () =>
    apiWrapper({
      endPoint: () =>
        axiosRequest({ transformResConfig: false }).get(`/administrators`),
      errorFailureAction: handleStatus500,
    }),
  generatePermalink: (projectId: string, params: { name: string }) =>
    apiWrapper({
      endPoint: (params = {}) =>
        axiosRequest({ transformResConfig: false }).get(
          `/projects/${projectId}/brainstormers/generate_permalink`,

          { params },
        ),
      params,
      errorFailureAction: handleStatus500,
    }),
  create: (brainstormer: object, projectId: string, params = {}) =>
    apiWrapper({
      endPoint: () =>
        axiosRequest({ transformResConfig: false }).post(
          `/projects/${projectId}/brainstormers`,
          {
            data: {
              attributes: brainstormer,
            },
          },
        ),
      params,
      errorFailureAction: handleStatus500,
    }),
  update: (
    brainstormer: object,
    projectId: string,
    brainstormerId: string,
    params = {},
  ) =>
    apiWrapper({
      endPoint: () =>
        axiosRequest({ transformResConfig: false }).patch(
          `/projects/${projectId}/brainstormers/${brainstormerId}`,
          {
            data: {
              attributes: brainstormer,
            },
          },
        ),
      params,
      errorFailureAction: handleStatus500,
    }),
  get: (projectId: string, brainstormerId: string, params = {}) =>
    apiWrapper({
      endPoint: () =>
        axiosRequest({ transformResConfig: false }).get(
          `/projects/${projectId}/brainstormers/${brainstormerId}`,
          {
            params,
          },
        ),
      params,
      errorFailureAction: handleStatus500,
    }),
  updateState: (
    state: 'publish' | 'unpublish' | 'archive' | 'unarchive',
    projectId: string,
    brainstormerId: string,
  ) =>
    apiWrapper({
      endPoint: () =>
        axiosRequest({ transformResConfig: false }).patch(
          `/projects/${projectId}/brainstormers/${brainstormerId}/${state}`,
        ),
      errorFailureAction: handleStatus500,
    }),
}

export default brainstormerAPI
